export const mapDataForBackend = (user) => ({
  userRole: user.userRole.value,
  organization: user.organization?.value || '',
  vehicleNumber: user.vehicleNumber,
  userPermissions: user.userPermissions,
});
